function WaitIcon(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 22 21"
      fill="#A8ADB2"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M10.833.333a10.333 10.333 0 100 20.667 10.333 10.333 0 000-20.667zm1.034 10.334a1.035 1.035 0 01-.3.733l-3.1 3.1a1.033 1.033 0 01-1.457-1.457l2.79-2.8V5.5a1.033 1.033 0 112.067 0v5.167z" />
    </svg>
  )
}

export default WaitIcon
